module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN202_1142767885.ac24c70e.png";